import React from "react";
import * as yup from 'yup';
import {injectIntl} from "react-intl";

import deLocale from "./yup.locale.de";
import enLocale from "./yup.locale.en";

class YupLocaleSetter extends React.Component {

    componentWillMount() {
        // setzen der locale in willMount statt didMount, da yup sonst die "alten" schemas noch verwendet
        // Diese Lösung ist für's erste akzeptiert, muss in Zukunft jedoch nochmal angegangen werden,
        // da componentWillMount() in einer neueren React Version entfällt
        yup.setLocale(this.props.intl.locale === 'de' ? deLocale : enLocale);
    }

    componentDidMount() {
        // Anhand der ausgewählten Sprache das lang-Attribut des <html>-tags auf den entsprechenden Wert setzen
        document.documentElement.lang = this.props.intl.locale;
    }

    render() {
        return null;
    }
}

export default injectIntl(YupLocaleSetter);
